var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPartnership({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 128) scale(0.72 0.72)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(-175.05 -175.05000000000004) scale(3.89 3.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 43.729 89.656 c -6.955 0 -15.869 -9.654 -24.542 -19.83 c -0.358 -0.42 -0.308 -1.052 0.113 -1.409 c 0.419 -0.36 1.051 -0.31 1.41 0.112 c 9.526 11.176 20.185 22.705 26.09 18.037 c 0.436 -0.344 1.063 -0.27 1.404 0.164 c 0.343 0.434 0.27 1.062 -0.164 1.404 C 46.716 89.181 45.27 89.656 43.729 89.656 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50.435 90 c -1.113 0 -2.226 -0.428 -3.067 -1.279 l -10.95 -11.085 c -0.388 -0.394 -0.384 -1.026 0.009 -1.415 c 0.393 -0.388 1.025 -0.383 1.414 0.009 l 10.95 11.085 c 0.895 0.906 2.363 0.916 3.27 0.02 c 0.906 -0.895 0.915 -2.362 0.019 -3.27 l -8.96 -9.07 c -0.388 -0.394 -0.384 -1.026 0.009 -1.414 c 0.393 -0.39 1.025 -0.384 1.414 0.008 l 8.96 9.071 c 1.671 1.692 1.654 4.429 -0.036 6.098 C 52.627 89.586 51.53 89.999 50.435 90 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 57.136 87.358 c -1.113 0 -2.226 -0.427 -3.067 -1.279 l -1.989 -2.015 c -0.388 -0.393 -0.384 -1.025 0.01 -1.414 c 0.392 -0.388 1.024 -0.384 1.414 0.01 l 1.988 2.014 c 0.431 0.437 1.01 0.679 1.631 0.683 c 0.614 -0.006 1.202 -0.232 1.639 -0.663 c 0.907 -0.896 0.917 -2.363 0.021 -3.271 l -8.96 -9.07 c -0.389 -0.394 -0.385 -1.026 0.008 -1.414 c 0.394 -0.39 1.026 -0.384 1.414 0.008 l 8.961 9.071 c 1.671 1.692 1.654 4.429 -0.037 6.098 C 59.329 86.944 58.232 87.358 57.136 87.358 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62.347 83.027 c -0.09 0 -0.181 -0.003 -0.272 -0.008 c -1.171 -0.068 -2.298 -0.568 -3.091 -1.372 c -0.388 -0.393 -0.384 -1.025 0.01 -1.414 c 0.392 -0.388 1.024 -0.385 1.414 0.01 c 0.449 0.455 1.1 0.739 1.784 0.779 c 0.673 0.046 1.276 -0.164 1.687 -0.57 c 0.907 -0.896 0.916 -2.363 0.021 -3.269 c -5.549 -6.826 -11.75 -12.647 -18.498 -17.379 c -1.197 0.652 -2.572 0.932 -4.159 0.844 c -5.18 5.316 -8.47 4.026 -11.251 1.824 c -0.029 -0.023 -0.057 -0.048 -0.083 -0.074 c -1.222 -1.214 -1.388 -3.112 -0.467 -5.346 c 2.068 -5.017 9.218 -11.146 14.616 -11.146 c 7.054 -0.273 15.343 1.155 20.583 3.553 c 0.502 0.229 0.723 0.823 0.493 1.325 c -0.229 0.501 -0.821 0.723 -1.325 0.493 c -4.981 -2.279 -12.906 -3.631 -19.712 -3.372 c -4.511 0.001 -11.023 5.583 -12.806 9.909 c -0.413 1.001 -0.744 2.35 -0.007 3.131 c 1.787 1.414 4.022 3.105 8.835 -2.014 c 0.212 -0.227 0.516 -0.339 0.827 -0.311 c 1.594 0.157 2.88 -0.115 3.925 -0.833 c 0.341 -0.235 0.792 -0.236 1.133 0.001 c 7.113 4.905 13.634 10.982 19.383 18.063 c 1.606 1.618 1.59 4.353 -0.102 6.024 C 64.536 82.614 63.478 83.027 62.347 83.027 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.91 50.768 H 25.96 c -0.552 0 -1 -0.447 -1 -1 s 0.448 -1 1 -1 h 10.95 c 0.552 0 1 0.447 1 1 S 37.463 50.768 36.91 50.768 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 63.1 75.662 c -0.338 0 -0.667 -0.171 -0.855 -0.48 c -0.287 -0.472 -0.138 -1.087 0.335 -1.374 l 7.279 -4.431 c 0.474 -0.287 1.088 -0.136 1.374 0.335 c 0.287 0.472 0.138 1.087 -0.335 1.374 l -7.279 4.431 C 63.456 75.615 63.277 75.662 63.1 75.662 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 19.123 72.841 H 8.994 c -0.552 0 -1 -0.447 -1 -1 V 43.738 c 0 -0.274 0.112 -0.536 0.311 -0.725 c 0.199 -0.188 0.467 -0.29 0.739 -0.274 c 5.314 0.263 11.083 1.146 18.157 2.778 c 0.271 0.063 0.503 0.235 0.642 0.476 c 0.139 0.241 0.171 0.529 0.088 0.794 l -7.852 25.349 C 19.949 72.556 19.562 72.841 19.123 72.841 z M 9.994 70.841 h 8.392 L 25.7 47.227 c -6.022 -1.35 -11.067 -2.131 -15.706 -2.431 V 70.841 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 81.007 72.841 H 70.876 c -0.438 0 -0.825 -0.285 -0.955 -0.704 L 62.07 46.788 c -0.082 -0.266 -0.051 -0.554 0.088 -0.794 c 0.139 -0.241 0.371 -0.414 0.643 -0.476 c 7.073 -1.632 12.843 -2.515 18.157 -2.778 c 0.272 -0.014 0.541 0.085 0.739 0.274 c 0.198 0.189 0.311 0.451 0.311 0.725 v 28.103 C 82.007 72.394 81.559 72.841 81.007 72.841 z M 71.613 70.841 h 8.393 V 44.796 c -4.639 0.3 -9.685 1.081 -15.707 2.431 L 71.613 70.841 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12.278 11.5 c -1.719 0 -3.117 -1.398 -3.117 -3.117 c 0 -1.718 1.398 -3.117 3.117 -3.117 c 1.718 0 3.117 1.398 3.117 3.117 C 15.395 10.102 13.997 11.5 12.278 11.5 z M 12.278 5.781 c -1.435 0 -2.603 1.167 -2.603 2.602 s 1.168 2.603 2.603 2.603 s 2.603 -1.168 2.603 -2.603 S 13.714 5.781 12.278 5.781 z M 4.732 10.812 c -0.101 0 -0.197 -0.06 -0.238 -0.159 C 4.222 9.995 4.536 9.237 5.194 8.964 C 5.544 8.819 5.582 8.51 5.582 8.383 c 0 -0.127 -0.037 -0.436 -0.388 -0.581 c -0.319 -0.132 -0.567 -0.381 -0.7 -0.7 c -0.132 -0.319 -0.132 -0.67 0 -0.99 l 0.675 -1.629 c 0.273 -0.658 1.031 -0.972 1.689 -0.699 c 0.35 0.145 0.596 -0.047 0.685 -0.136 c 0.09 -0.09 0.282 -0.335 0.137 -0.686 c -0.132 -0.319 -0.132 -0.671 0 -0.989 c 0.132 -0.319 0.381 -0.568 0.7 -0.7 L 10.008 0.6 c 0.659 -0.272 1.416 0.041 1.689 0.7 c 0.145 0.35 0.455 0.388 0.581 0.388 c 0.126 0 0.436 -0.038 0.581 -0.388 c 0.132 -0.319 0.38 -0.568 0.7 -0.7 c 0.318 -0.132 0.67 -0.133 0.99 0 l 1.628 0.674 c 0.319 0.132 0.568 0.381 0.7 0.7 c 0.132 0.319 0.132 0.671 0 0.99 c -0.145 0.35 0.047 0.596 0.136 0.685 c 0.089 0.089 0.334 0.282 0.685 0.136 c 0.319 -0.132 0.671 -0.132 0.99 0 c 0.32 0.132 0.568 0.381 0.7 0.7 l 0.675 1.628 c 0.132 0.319 0.132 0.671 0 0.99 c -0.132 0.319 -0.381 0.568 -0.7 0.7 c -0.35 0.145 -0.388 0.455 -0.388 0.581 c 0 0.126 0.038 0.436 0.389 0.581 c 0.658 0.273 0.972 1.031 0.699 1.689 c -0.055 0.131 -0.206 0.193 -0.336 0.139 c -0.131 -0.054 -0.194 -0.205 -0.139 -0.336 c 0.164 -0.396 -0.024 -0.853 -0.421 -1.017 c -0.655 -0.271 -0.706 -0.877 -0.706 -1.056 c 0 -0.369 0.185 -0.841 0.705 -1.056 c 0.192 -0.079 0.342 -0.229 0.421 -0.421 c 0.08 -0.192 0.08 -0.404 0 -0.596 l -0.675 -1.628 c -0.08 -0.192 -0.229 -0.342 -0.421 -0.421 c -0.192 -0.08 -0.404 -0.08 -0.596 0 c -0.655 0.272 -1.119 -0.121 -1.246 -0.248 c -0.261 -0.261 -0.463 -0.725 -0.248 -1.246 c 0.08 -0.192 0.08 -0.404 0 -0.596 c -0.08 -0.192 -0.229 -0.342 -0.421 -0.421 l -1.628 -0.674 c -0.192 -0.08 -0.404 -0.08 -0.596 0 c -0.192 0.08 -0.342 0.229 -0.421 0.421 c -0.271 0.655 -0.877 0.706 -1.056 0.706 c -0.369 0 -0.84 -0.185 -1.056 -0.705 c -0.165 -0.397 -0.621 -0.586 -1.018 -0.422 L 8.576 1.749 c -0.192 0.08 -0.342 0.229 -0.421 0.421 c -0.08 0.192 -0.08 0.404 0 0.596 c 0.216 0.52 0.013 0.985 -0.248 1.246 C 7.647 4.274 7.183 4.476 6.662 4.26 C 6.266 4.096 5.809 4.285 5.644 4.681 L 4.969 6.31 c -0.08 0.192 -0.08 0.404 0 0.596 c 0.08 0.192 0.229 0.342 0.422 0.421 c 0.521 0.216 0.706 0.687 0.705 1.056 c 0 0.179 -0.051 0.784 -0.705 1.055 c -0.397 0.165 -0.586 0.621 -0.422 1.017 c 0.054 0.131 -0.008 0.282 -0.139 0.336 C 4.798 10.806 4.765 10.812 4.732 10.812 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(3.89 0 0 3.89 -1.9444444444444287 -1.9444444444444287) ",
    strokeLinecap: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnership);
export default __webpack_public_path__ + "static/media/partnership.d3899703.svg";
export { ForwardRef as ReactComponent };